import React from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { FLOWS_ENUM } from '../../common/enums';
import Success from '../../components/payment/common/success/Success';
import ApplySuccessFields from '../../components/payment/common/success/ApplySuccessFields';

const ApplySuccess = () => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.APPLY_LICENSE} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Success
            successComponent={() => <ApplySuccessFields />}
            flow={FLOWS_ENUM.APPLY_LICENSE}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default ApplySuccess;
